export default __webpack_public_path__ + "static/media/ML_Example_PLN.0867ef03.png";